export const columnsWidth = [
  120, 90, 370, 90, 90, 90, 120, 120, 130, 90, 90, 160, 90, 90, 90, 90, 90, 90, 90,
]

// Shared fixed-grid constants: parent table = selection(48) + expand(48) + data columns;
// child targets table = selection(48) + spacer(48) + data columns. Totals must stay equal.
export const SELECTION_COLUMN_WIDTH = 48
export const EXPAND_COLUMN_WIDTH = 48
export const TABLE_SCROLL_X =
  columnsWidth.reduce((sum, width) => sum + width, 0) + SELECTION_COLUMN_WIDTH + EXPAND_COLUMN_WIDTH

// Placements child table has no rowSelection, so one leading spacer covers both slots.
export const PLACEMENT_LEADING_SPACER_WIDTH = SELECTION_COLUMN_WIDTH + EXPAND_COLUMN_WIDTH

const PLACEMENT_BID_SLOT_INDEXES = [3, 4, 5, 6, 7]
const PLACEMENT_BID_COLUMNS_COUNT = 5

function sumWidthsBySlots(slotIndexes: number[]): number {
  return slotIndexes.reduce((sum, slotIndex) => sum + columnsWidth[slotIndex], 0)
}

function splitWidthEvenly(total: number, parts: number): number[] {
  const baseWidth = Math.floor(total / parts)
  return Array.from({ length: parts }, (_, index) =>
    index === parts - 1 ? total - baseWidth * (parts - 1) : baseWidth
  )
}

// Five placement bid columns share the parent's four CPC slots (3-6) so the
// metric columns after them land on the exact same grid tracks.
export const placementBidColumnsWidth = splitWidthEvenly(
  sumWidthsBySlots(PLACEMENT_BID_SLOT_INDEXES),
  PLACEMENT_BID_COLUMNS_COUNT
)
